/// <amd-module name="Test/TestPlansHubRefresh/TestPlanCloneProgress/Component/TestPlanCloneProgressConnectedView" />
import * as React from "react";
import { connect } from "react-redux";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { TestPlanCloneProgressModule } from "Test/TestPlansHubRefresh/TestPlanCloneProgress/Redux/TestPlanCloneProgressModule";
import { ITestPlanCloneProgressAwareState, CloneOperationState } from "Test/TestPlansHubRefresh/TestPlanCloneProgress/Redux/TestPlanCloneProgressContracts";
import * as Resources from "Test/TestPlansHubRefresh/TestPlanCloneProgress/Resources";
import { Components, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { IVssComponentContext } from "VSS/Platform/Layout";
import { Toast } from "VSSUI/Toast";

export interface ITestPlanCloneProgressOwnProps extends IVssComponentProperties {
    opId: number,
    planId: number
}

export interface ITestPlanCloneProgressViewProps {
    state: CloneOperationState
}

export class TestPlanCloneProgressView extends VssComponent<ITestPlanCloneProgressOwnProps & ITestPlanCloneProgressViewProps> {
    private _toast: JSX.Element | null;
    constructor(props: ITestPlanCloneProgressOwnProps & ITestPlanCloneProgressViewProps, context?: IVssComponentContext) {
        super(props);
        this._toast = null;
    }

    public render(): JSX.Element {
        if (this.props.state) {
            if (this.props.state !== CloneOperationState.Succeeded && this.props.state !== CloneOperationState.Failed) {
                this._toast = <Toast className="clone-progress-toast" message={Resources.CloneProgressToastState} />
            }
            else {
                this._toast = null;
            }
        }
        return (
            <DynamicModuleLoader modules={[TestPlanCloneProgressModule(this.props.planId, this.props.opId)]}>
                {this._toast}
            </DynamicModuleLoader>
        );
    }
}

function mapStateToProps(state: ITestPlanCloneProgressAwareState): Partial<ITestPlanCloneProgressViewProps> {
    let cloneProgressState;
    if (state.testPlanCloneProgressState && state.testPlanCloneProgressState.state) {
        cloneProgressState = state.testPlanCloneProgressState.state;
    }
    return {
        state: cloneProgressState
    };
}

export const TestPlanCloneProgressConnectedView = connect(mapStateToProps, null)(TestPlanCloneProgressView);
Components.add("testplan-clone-progress", TestPlanCloneProgressConnectedView);
